/**
 * Form.Item rules for @gpstrackit/gtc-react-controls.
 * Built-in `required` only treats empty length; strings of only spaces pass validation.
 * Use these rules on text inputs where whitespace-only should show the same required message.
 *
 * @param {string} requiredMessage — e.g. intl `messages['required_field']`
 * @returns {Array} rules array for Form.Item `rules` prop
 */
export function getRequiredTrimmedNonEmptyRules(requiredMessage) {
  return [
    { required: true, message: requiredMessage },
    (_values, newValue) =>
      String(newValue ?? "").trim().length === 0 ? requiredMessage : undefined,
  ];
}

/**
 * Same as {@link getRequiredTrimmedNonEmptyRules} when `isRequired` is true; otherwise no rules (optional field).
 * @param {string} requiredMessage
 * @param {boolean} isRequired
 * @returns {Array}
 */
export function getTrimmedNonEmptyTextRules(requiredMessage, isRequired) {
  if (!isRequired) return [];
  return getRequiredTrimmedNonEmptyRules(requiredMessage);
}
